import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { DocumentMask, DocumentMaskParam } from '@/modules/document/adapters/document-mask.type.ts';

export class DocumentMaskAdapter {
  private static map(response: any): DocumentMask {
    return {
      mask: response['mask'],
      params: response['params'].map(
        (param: any): DocumentMaskParam => ({
          start: param['start'] - 1,
          end: param['end'],
        }),
      ),
    };
  }

  static mapList(response: ItemsDto<any>) {
    return response.items.map(DocumentMaskAdapter.map);
  }
}
